import { Component } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatDialogClose, MatDialogRef } from '@angular/material/dialog';
import { environment } from 'src/environments/environment';

@Component({
    selector: 'app-about',
    templateUrl: './about.component.html',
    styleUrls: ['./about.component.scss'],
    imports: [MatCardModule, MatButtonModule, MatDialogClose]
})
export class AboutComponent {
    public version: string = environment.version;
    constructor(public dialogRef: MatDialogRef<AboutComponent>) {}
}
